<template>
    <div>
        <headful
			title="Caseen - Scoreboard"
		/>
        <h1>Caseen Leaderboard</h1>
        <hr><br>
        <div>
            The leaderboards showcase the profiles of the most accomplished Caseen authors and learners:
            <br><br>
            <b>Author Score</b> = (50 points per case authored) + (# of users who have completed each case &times; Average quality rating)
            <br>
            <b>Learner Score</b> = (20 points per case completed) + (5 points per case review filled out)
        </div>
        <br><hr><br>
        <div style="display: flex; justify-content: space-around; flex-wrap: wrap;">
            <md-card style="min-width: 45%; padding: 1%; margin-bottom: 20px; overflow: auto;">
                <h2>Top Case Authors</h2>
                <hr>
                <br>
                <table style="border: 1px dotted black; border-bottom: none;">
                    <thead style="font-weight: bold">
                        <tr>
                            <td>Rank</td>
                            <td>Username</td>
                            <td>Author Score</td>
                        </tr>
                    </thead>
                    <tr v-for="(scoreboardEntry, scoreboardIndex) in scoreboardData.authorScoreboard" :key="scoreboardIndex">
                        <td>
                            # {{scoreboardIndex + 1}}
                        </td>
                        <td>
                            <Trophy :trophy-index="scoreboardIndex"/>
                            <a target="_blank" :href="'/user/' + scoreboardEntry.profile.pid">
                                {{scoreboardEntry.profile.uname}}
                            </a>
                        </td>
                        <td>
                            {{scoreboardEntry.score}}
                        </td>
                    </tr>
                </table>
            </md-card>
            <md-card style="min-width: 45%; padding: 1%; margin-bottom: 20px; overflow: auto;">
                <h2>Top Learners</h2>
                <hr>
                <br>
                <table style="border: 1px dotted black; border-bottom: none;">
                    <thead style="font-weight: bold">
                        <tr>
                            <td>Rank</td>
                            <td>Username</td>
                            <td>Learner Score</td>
                        </tr>
                    </thead>
                    <tr v-for="(scoreboardEntry, scoreboardIndex) in scoreboardData.learnerScoreboard" :key="scoreboardIndex">
                        <td>
                            # {{scoreboardIndex + 1}}
                        </td>
                        <td>
                            <Trophy :trophy-index="scoreboardIndex"/>
                            <a target="_blank" :href="'/user/' + scoreboardEntry.profile.pid">
                                {{scoreboardEntry.profile.uname}}
                            </a>
                        </td>
                        <td>
                            {{scoreboardEntry.score}}
                        </td>
                    </tr>
                </table>
            </md-card>
        </div>    
    </div>
</template>

<script>
    import APIRequests from "./APIRequests.js"
    import Trophy from "./Trophy.vue"
    
    export default {
        data: function(){
            return {
                scoreboardData: {}
            }
        },
        components: {
            Trophy,
        },
        methods: {
            getScoreboard: function(){
                var api_url = this.$store.state.api_url + "/api/users/scoreboard"
                return APIRequests.getJSONData(
                    api_url, 
                    this.$store.state.jwtToken
                ).then((data) => {
                    this.scoreboardData = data
                })
            }
        },
        mounted: function(){
            this.$nextTick(function () {
                this.getScoreboard()
            })
        }
    }
</script>

